module.exports = __webpack_public_path__ + "static/img/banner-20q4ika-uc-voucher1000.d70ce5d.jpg";